// React Imports
import * as React from "react";
import {useState, useEffect, useMemo, useRef} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {DataGridPro} from "@mui/x-data-grid-pro";
import {useGridApiRef
} from '@mui/x-data-grid';
import Box from "@mui/material/Box";
import {
    Stack,
    Tooltip
} from "@mui/material";
import Typography from "@mui/material/Typography";



// App Imports
import {
    contractUpdate, contractUpdateWithTest,
    deleteContract, deleteContractById,
    getContractById, getProductContractHierarchy,
    getSampleContracts,
} from "../../Contract/ContractClient";
import {changeWorkQueue} from "../workQueueSlice";
import {
    randomizeInputCdpvValues,
} from "../../ContractDataPointValue/ContractDataPointValueClient";
import LinearIndeterminate from "../../CommonComponents/Progress";
import {changeWorkSubmitting} from "../../Work/workSubmittingSlice";
import {WorkQueueContractGridColumns} from "./WorkQueueContractGridColumns";
import {changeContractStatsControls} from "../WorkStats/contractStatsControlsSlice";
import ContractAddFromGridDialogue from "./ContractAddFromGridDialogue";
import ProductGuildDialogue from "../../ExternalData/Product/ProductGuildDialogue";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";




// main function
export default function WorkQueueContractsGrid(props ) {

    // ****************** BEGIN STATES ****************************

    const [contracts, setContracts] = useState([]);
    const [collapsed, setCollapsed] = useState(false);
    const [fetching, setFetching] = useState(true);
    const [showDrawer, setShowDrawer] = useState(false);
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [selectedRow, setSelectedRow] = React.useState([]);
    const [contractIdX, setContractIdX] = React.useState([]);
    const [contractMcode, setContractMcode] = React.useState([]);
    const [contractName, setContractName] = React.useState([]);
    const [contractDescription, setContractDescription] = React.useState([]);
    const [contractDrawerMode, setContractDrawerMode] = React.useState([]);
    const [contractDrawerState, setContractDrawerState] = React.useState(false);
    const [showMyContract, setShowMyContract] = React.useState("nada");
    const [contractGridFilter, setContractGridFilter] = React.useState("0");
    const [selectedContracts, setSelectedContracts] = React.useState([]);
    const [submitting, setSubmitting] = useState(false);
    const [myContractList, setMyContractList] =  useState();

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorGuildMultiSelect = useSelector((state) => state.productSlc.value.guildMultiSelectState);
    const selectorProductGuildDialogueState = useSelector((state) => state.workQueueSlc.value.productGuildDialogueState);

    const selectorContractList = useSelector((state) => state.workQueueSlc.value.mousedContractContractList);
    const selectorContractId = useSelector((state) => state.workQueueSlc.value.selectedContractId);
    const controlsContractId = useSelector((state) => state.workQueueSlc.value.mousedContractId);
    const controlsPropertyId = useSelector((state) => state.workQueueSlc.value.mousedContractPropertyId);
    const controlsLaborGroup = useSelector((state) => state.workQueueSlc.value.mousedContractLaborGroup);
    const controlsHierarchy = useSelector((state) => state.workQueueSlc.value.mousedContractHierarchyNew);
    const menuContractId = useSelector((state) => state.workQueueSlc.value.actionMenuContractId);
    const menuContractName = useSelector((state) => state.workQueueSlc.value.actionMenuName);
    const menuContractLevel = useSelector((state) => state.workQueueSlc.value.actionMenuName);
    const menuProductId = useSelector((state) => state.workQueueSlc.value.actionMenuProductId);
    const menuFailedExpressionCount = useSelector((state) => state.workQueueSlc.value.actionMenuFailedExpressionCount);
    const menuFailedFilterCount = useSelector((state) => state.workQueueSlc.value.actionMenuFailedFilterCount);
    const menuInputMissingCount = useSelector((state) => state.workQueueSlc.value.actionMenuInputMissingCount);
    const menuAction = useSelector((state) => state.workQueueSlc.value.actionMenuAction);

    const expandContracts = useSelector((state) => state.workQueueSlc.value.contractExpand);
    const expandHierarchical = useSelector((state) => state.workQueueSlc.value.contractExpandHierarchical);
    const expandSeasonNumber = useSelector((state) => state.workQueueSlc.value.contractExpandSeasonNumber);
    const expandProductId = useSelector((state) => state.workQueueSlc.value.contractExpandProductId);
    const expandContractType = useSelector((state) => state.workQueueSlc.value.contractExpandContractType);
    const expandParticipationsTemplate = useSelector((state) => state.workQueueSlc.value.contractExpandParticipationsTemplate);
    const expandLaborGroup = useSelector((state) => state.workQueueSlc.value.contractExpandLaborGroup);
    const expandGuild = useSelector((state) => state.workQueueSlc.value.contractExpandGuild);
    const expandOption = useSelector((state) => state.workQueueSlc.value.contractExpandOption);
    const expandCast = useSelector((state) => state.workQueueSlc.value.contractExpandCast);
    const expandContractLevel = useSelector((state) => state.workQueueSlc.value.contractExpandContractLevel);


    const submitBar = useSelector((state) => state.workSubmittingSlc.value.submitting);
    const selectorProductId = useSelector((state) => state.obligationHierarchySlc.value.myProductId);
    const selectorExpansionDepth = useSelector((state) => state.workSlc.value.expansionDepth);
    const selectorTitleId = useSelector((state) => state.workQueueSlc.value.propertyDropdownTitleId);
    const selectorTitle = useSelector((state) => state.workQueueSlc.value.propertyDropdownTitle);
    const selectorMultiSingle = useSelector((state) => state.workQueueSlc.value.propertyDropdownMultiSingle);
    // const selectorExpansionDepth = useSelector((state) => state.workQueueSlc.value.propertyDropdownExpansionDepth);
    const selectorContractIdGeneratedFromAbstract = useSelector((state) => state.contractSlc.value.contractIdGeneratedFromAbstract);
    const selectorWorkQueueCGridAbstractRefresh = useSelector((state) => state.workQueueSlc.value.workQueueCGridAbstractRefresh);

    const selectorNewSetupContractId = useSelector((state) => state.workQueueSlc.value.newSetupContractId);

    const controlsTestScenarioPeriodEnd = useSelector((state) => state.workQueueSlc.value.testScenarioPeriodEnd);
    const controlsTestScenarioPropertyId = useSelector((state) => state.workQueueSlc.value.testScenarioPropertyId);
    const controlsTestScenarioList = useSelector((state) => state.workQueueSlc.value.testScenarioList);
    const controlsTestScenarioNumber = useSelector((state) => state.workQueueSlc.value.testScenarioNumber);
    const controlsTestScenarioName = useSelector((state) => state.workQueueSlc.value.testScenarioName);
    const controlsTestScenarioSelectedNumber = useSelector((state) => state.workQueueSlc.value.testScenarioSelectedNumber);

    const currentUserName = localStorage.getItem('userName');
    const contractArray = useSelector((state) => state.workQueueSlc.value.mousedContractContractIdArray);

    const selectorExperience = useSelector((state) => state.workQueueSlc.value.workQueueExperience);

    const selectorCGridRefresh = useSelector((state) => state.workQueueSlc.value.workQueueCGridRefresh);


    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    // ****************** BEGIN FETCH ****************************
    //
    // const fetchContracts = () =>{
    //     if (selectorTitleId > 0){
    //         dispatchData(changeWorkSubmitting({submitting: true }));
    //         console.log(" selectorTitleId ", selectorTitleId);
    //         console.log(" selectorMultiSingle ", selectorMultiSingle);
    //     // getProductContractHierarchy(selectorProductId)
    //     getProductContractHierarchy(selectorTitleId, selectorMultiSingle)
    //     // getProductContracts(selectorProductId)
    //     // getQueueC()

    //         .then(data => {
    //             console.log("contracts fetched with getProductContractHierarchy");
    //             console.log(data);
    //             setContracts(data);
    //                    if(selectorExperience !== null){
    //                     console.log("we are going to try to find the build contract's data");
    //                     console.log("selectorContractId = ", selectorContractId);
    //                     console.log("selectorNewSetupContractId = ", selectorNewSetupContractId);
    //                 const matchRow = data.find(
    //                     r => String(r.contractId) === String(selectorNewSetupContractId) // type-safe match
    //                 );
    //                     dispatchData(changeWorkQueue({contractExpand: true,
    //                         contractExpandHierarchical: matchRow.seriesId !== null,
    //                         contractExpandSeriesId: matchRow.seriesId,
    //                         contractExpandSeasonId: matchRow.seasonId,
    //                         contractExpandSeasonNumber: matchRow.seasonNumber,
    //                         contractExpandProductId: matchRow.propertyId,
    //                         contractExpandContractType: matchRow.contractType,
    //                         contractExpandParticipationsTemplate: matchRow.participationsTemplate,
    //                         contractExpandLaborGroup: matchRow.laborGroup,
    //                         contractExpandGuild: matchRow.guild,
    //                         contractExpandOption: matchRow.option,
    //                         contractExpandCast: matchRow.parentId,
    //                         contractExpandContractLevel: matchRow.contractLevel,
    //                         workQueueCGridRefresh: false,
    //                         workQueueCDPGridRefresh: false,
    //                         workQueueCSGridRefresh: false,
    //                         workQueueDrawerState: false,
    //                         cdpDrawerMode: null,
    //                         actionMenuAction: null
    //                     }));
    //                     console.log("matchRow");
    //                     console.log(matchRow);
    //                 handleClickedRow(matchRow);}
    //                 dispatchData(changeWorkSubmitting({submitting: false }));
    //                 dispatchData(changeWorkQueue({workQueueExperience: null}));
    //         }
    //         );}};
    //
    //
    //
    // const handleClickedRow = (rowFull) => {
    //
    //     console.log('Contract data from clicked row');
    //     console.log(rowFull);
    //     dispatchData(changeWorkQueue({
    //         selectedContractId: rowFull.contractId,
    //         selectedContractName: rowFull.name,
    //         selectedContractLevel: rowFull.contractLevel,
    //         selectedContractProductId: rowFull.propertyId,
    //         selectedContractType: rowFull.contractType,
    //         selectedContractGuild: rowFull.guild,
    //         selectedContractFailedExpressionCount: rowFull.failedExpressionCount,
    //         selectedContractFailedFilterCount: rowFull.failedFilterCount,
    //         selectedContractInputMissingCount: rowFull.inputMissingCount,
    //         selectedContractPropertyId: rowFull.propertyId,
    //         selectedContractStatus: rowFull.status,
    //         selectedContractDescription: rowFull.description,
    //         selectedContractDisplayFolders: true,
    //         contractHeaderState: true,
    //         selectedContractSectionId: 0,
    //         workQueueCDPGridRefresh: true,
    //         workQueueCSGridRefresh: true,
    //         triggerAdvance: false, contractFoldersDisplay: true
    //     }));
    //
    // };

    const handleClickedRow = React.useCallback((rowFull) => {
        console.log("Contract data from clicked row");
        console.log(rowFull);

        dispatchData(changeWorkQueue({
            selectedContractId: rowFull.contractId,
            selectedContractName: rowFull.name,
            selectedContractLevel: rowFull.contractLevel,
            selectedContractProductId: rowFull.propertyId,
            selectedContractType: rowFull.contractType,
            selectedContractGuild: rowFull.guild,
            selectedContractFailedExpressionCount: rowFull.failedExpressionCount,
            selectedContractFailedFilterCount: rowFull.failedFilterCount,
            selectedContractInputMissingCount: rowFull.inputMissingCount,
            selectedContractPropertyId: rowFull.propertyId,
            selectedContractStatus: rowFull.status,
            selectedContractDescription: rowFull.description,
            selectedContractDisplayFolders: true,
            contractHeaderState: true,
            selectedContractSectionId: 0,
            workQueueCDPGridRefresh: true,
            workQueueCSGridRefresh: true,
            triggerAdvance: false,
            contractFoldersDisplay: true
        }));
    }, [dispatchData]);

    const fetchContracts = React.useCallback(() => {
        if (selectorTitleId <= 0) return Promise.resolve();

        dispatchData(changeWorkSubmitting({ submitting: true }));

        console.log("selectorTitleId =", selectorTitleId);
        console.log("selectorMultiSingle =", selectorMultiSingle);

        return getProductContractHierarchy(selectorTitleId, selectorMultiSingle)

            .then(data => {
                console.log("contracts fetched with getProductContractHierarchy");
                console.log(data);

                setContracts(data);

                if (selectorExperience !== null) {
                    const matchRow = data.find(
                        r => String(r.contractId) === String(selectorNewSetupContractId)
                    );

                    if (matchRow) {
                        dispatchData(changeWorkQueue({
                            contractExpand: true,
                            contractExpandHierarchical: matchRow.seriesId !== null,
                            contractExpandSeriesId: matchRow.seriesId,
                            contractExpandSeasonId: matchRow.seasonId,
                            contractExpandSeasonNumber: matchRow.seasonNumber,
                            contractExpandProductId: matchRow.propertyId,
                            contractExpandContractType: matchRow.contractType,
                            contractExpandParticipationsTemplate: matchRow.participationsTemplate,
                            contractExpandLaborGroup: matchRow.laborGroup,
                            contractExpandGuild: matchRow.guild,
                            contractExpandOption: matchRow.option,
                            contractExpandCast: matchRow.parentId,
                            contractExpandContractLevel: matchRow.contractLevel,
                            workQueueCDPGridRefresh: false,
                            workQueueCSGridRefresh: false,
                            workQueueDrawerState: false,
                            cdpDrawerMode: null,
                            actionMenuAction: null
                        }));

                        handleClickedRow(matchRow);
                    }
                }

                dispatchData(changeWorkQueue({ workQueueExperience: null }));
            })
            .finally(() => {
                dispatchData(changeWorkSubmitting({ submitting: false }));
            });
    }, [
        selectorTitleId,
        selectorMultiSingle,
        selectorExperience,
        selectorNewSetupContractId,
        dispatchData,
        handleClickedRow
    ]);



    const fetchingContractsRef = React.useRef(false);


    useEffect(() => {
        if (!selectorCGridRefresh) return;
        if (fetchingContractsRef.current) return;

        fetchingContractsRef.current = true;

        console.log("product contracts fetch triggered by grid refresh = true");

        if (selectorWorkQueueCGridAbstractRefresh === true) {
            dispatchData(changeWorkQueue({
                selectedContractId: selectorContractIdGeneratedFromAbstract
            }));
        }

        fetchContracts().finally(() => {
            fetchingContractsRef.current = false;

            dispatchData(changeWorkQueue({
                workQueueCGridRefresh: false,
                actionMenuAction: null
            }));
        });
    }, [
        selectorCGridRefresh,
        selectorWorkQueueCGridAbstractRefresh,
        selectorContractIdGeneratedFromAbstract,
        fetchContracts,
        dispatchData
    ]);
    //
    // useEffect(() => {
    //     if (!selectorCGridRefresh) return;
    //
    //     console.log("product contracts fetch triggered by grid refresh = true");
    //
    //     if (selectorWorkQueueCGridAbstractRefresh === true) {
    //         console.log(
    //             "selectorContractIdGeneratedFromAbstract =",
    //             selectorContractIdGeneratedFromAbstract
    //         );
    //
    //         dispatchData(changeWorkQueue({
    //             selectedContractId: selectorContractIdGeneratedFromAbstract
    //         }));
    //     }
    //
    //     fetchContracts().finally(() => {
    //         dispatchData(changeWorkQueue({
    //             workQueueCGridRefresh: false,
    //             actionMenuAction: null
    //             // workQueueCGridAbstractRefresh: false
    //         }));
    //     });
    // }, [
    //     selectorCGridRefresh,
    //     selectorWorkQueueCGridAbstractRefresh,
    //     selectorContractIdGeneratedFromAbstract,
    //     fetchContracts,
    //     dispatchData
    // ]);


    // ****************** END FETCH ****************************


    // ******************** BEGIN USE EFFECTS *******************
    //
    // useEffect(() => {
    //     console.log("product contracts fetch triggered by grid refresh = true");
    //
    //     if(selectorWorkQueueCGridAbstractRefresh === true){
    //     console.log("selectorContractIdGeneratedFromAbstract =", selectorContractIdGeneratedFromAbstract);
    //     dispatchData(changeWorkQueue({selectedContractId: selectorContractIdGeneratedFromAbstract}));
    //     console.log("selectorContractId = ", selectorContractId);}
    //
    //
    //
    //     fetchContracts();
    //     dispatchData(changeWorkQueue({workQueueCGridRefresh: false,actionMenuAction: null
    //         // , workQueueCGridAbstractRefresh: false
    //     }));
    // }, [useSelector((state) => state.workQueueSlc.value.workQueueCGridRefresh)===true]);
    //
    //
    // useEffect(() => {
    //     if (selectorProductId > 0){
    //         console.log("Loading Contracts Grid because of refresh");
    //         fetchContracts();
    //         dispatchData(changeWorkQueue({workQueueCGridRefresh: false}));
    //     }
    //     else{dispatchData(changeWorkQueue({workQueueCGridRefresh: false}))}
    // }, [useSelector((state) => state.workQueueSlc.value.workQueueCGridRefresh)===true]);
    //
    //
    // useEffect(() => {
    //     if (menuAction !== "Delete") return;
    //     deleteMultipleContracts();
    //     dispatchData(changeWorkQueue({actionMenuAction: null}));
    // }, [menuAction === "Delete"]);

    useEffect(() => {
        if (menuAction !== "Delete") return;

        deleteMultipleContracts();
        dispatchData(changeWorkQueue({ actionMenuAction: null }));
    }, [menuAction, dispatchData]);


    // useEffect(() => {
    //     console.log("handleCalc triggered by actionMenuAction=== Calc");
    //     dispatchData(changeWorkQueue({actionMenuAction: null}));
    //     handleCalc();
    // }, [ menuAction === "Calc"]);
    // // }, [useSelector((state) => state.workQueueSlc.value.actionMenuAction)==="Calc"]);


    useEffect(() => {
        if (menuAction !== "Test") return;

        console.log("handleCalc triggered by actionMenuAction===Test");
        dispatchData(changeWorkQueue({ actionMenuAction: null }));
        handleTest();
    }, [menuAction]);


    useEffect(() => {
        if (menuAction !== "Calc") return;

        console.log("handleCalc triggered by actionMenuAction===Calc");
        dispatchData(changeWorkQueue({ actionMenuAction: null }));
        handleCalc();
    }, [menuAction]);

    // useEffect(() => {
    //     if (menuAction !== "Add") return;
    //     handleMenuAdd();
    //     dispatchData(changeWorkQueue({actionMenuAction: null}));
    // }, [menuAction === ""]);

    useEffect(() => {
        if (menuAction !== "Add") return;

        handleMenuAdd();
        dispatchData(changeWorkQueue({ actionMenuAction: null }));
    }, [menuAction, dispatchData]);

    //
    // useEffect(() => {
    //     handleFinalize();
    //      dispatchData(changeWorkQueue({actionMenuAction: null, workQueueFinalize: false}));
    // }, [useSelector((state) => state.workQueueSlc.value.workQueueFinalize)===true]);

    // ******************** END USE EFFECTS *******************



    // and this I'm not sure about, other than that it returns a message (not a console log) if no data is returned
    const renderContracts = contracts => {
        if (contracts.length <= 0) {
            return "No Data";
        }}



    // ***************** BEGIN CONTROLS ***************************

    const handleMenuAdd = (rowData) => {
        dispatchData(changeWorkQueue({
            actionMenuAction: "Add"
        }))
        console.log("this is the contract selected by the menu click: ", menuContractId);
        console.log("menuContractName: ", menuContractName);
        console.log("menuContractLevel: ", menuContractLevel);
        console.log("menuProductId: ", menuProductId);
        console.log("menuFailedExpressionCount: ", menuFailedExpressionCount);
        console.log("menuFailedFilterCount: ", menuFailedFilterCount);
        console.log("menuInputMissingCount: ", menuInputMissingCount);
        console.log("menuAction: ", menuAction);
        console.log("action: ", "Add");
        console.log("Add to All Contracts Under This Hierarchy:");
    };


    const handleEdit = (selectContractId, selectContractMcode, selectContractName, selectContractDescription, rowFull) => {
        setContractIdX(selectContractId);
        setContractName(selectContractName);
        setContractMcode(selectContractMcode);
        setContractDescription(selectContractDescription);

        console.log("This is show drawer");
        console.log(showDrawer);
        console.log("This is the contract id chosen");
        console.log(selectContractId);
        console.log("This is the contract mcode chosen");
        console.log(selectContractMcode);
        console.log("This is the contract name chosen");
        console.log(selectContractName);
        console.log("This is the contract description chosen");
        console.log(selectContractDescription);
        console.log("Here's the row");
        console.log(rowFull);
        console.log("Here's the mcode from the row");
        console.log(rowFull[1]);
        console.log("Here's the stringify");
        setContractDrawerMode("Edit");
        setContractDrawerState(!contractDrawerState);
        getContractById(contractIdX);
        console.log(JSON.stringify(getSampleContracts, null, 2))
    }

    const deleteMultipleContracts = () => {
        if(myContractList !== null && myContractList !== undefined && myContractList !== '') {
            dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "info", crudMessage: "Delete initiated"}));
            setSubmitting(true);
            dispatchData(changeWorkSubmitting({submitting: true }));
            console.log("contracts that will be deleted");
            console.log(myContractList);
            contractUpdate(contractArray, [], [],'Delete Contracts',
                null, null, currentUserName, true)
            // deleteMultipleContractsById(myContractList)
                .then(() => {
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Records deleted"}));
                    dispatchData(changeWorkSubmitting({submitting: false }));
                    dispatchData(changeWorkQueue({
                        selectedContractId: 0,
                        selectedContractName: null,
                        selectedContractLevel: null,
                        selectedContractProductId: null,
                        selectedContractType: null,
                        selectedContractGuild: null,
                        selectedContractFailedExpressionCount: null,
                        selectedContractFailedFilterCount: null,
                        selectedContractInputMissingCount: null,
                        selectedContractPropertyId: null,
                        selectedContractStatus: null,
                        selectedContractDescription: null,
                        workQueueCGridRefresh: true,
                        actionMenuAction: null
                    }));
                    dispatchData(changeContractStatsControls({gridRefresh: true}));
                })
                .catch(err => {
                    err.response.json().then(res => {
                        console.log(res);
                        // errorNotification(
                        //     "There was an issue",
                        //     `${res.message} [${res.status}] [${res.error}]`
                        // )
                    });
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Deletion failed"}));
                })
                .finally(()=>{setSubmitting(false)});
        }
    }

    // const handleFinalize = () => {
    //     dispatchData(changeWorkQueue({workQueueFinalize: false}));
    //     if (controlsPropertyId !== null && controlsPropertyId !== undefined && controlsPropertyId !== '') {
    //         dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "info", crudMessage: "Finalizing initiated"}));
    //         setSubmitting(true);
    //         dispatchData(changeWorkSubmitting({submitting: true }));
    //         console.log("finalizing contracts");
    //         console.log("controlsPropertyId", controlsPropertyId);
    //         console.log("controlsPropertyId", controlsLaborGroup);
    //         if(controlsLaborGroup !== null && controlsLaborGroup !== undefined && controlsLaborGroup !== '') {
    //             console.log("finalizing by labor group");
    //             finalizeLaborGroup(controlsPropertyId,"Unapproved",controlsLaborGroup)
    //                 .then(() => {
    //                     // successNotification("Contract deleted", `Contract with id ${contractId} was deleted`);
    //                     updateStatusByContractList(selectorContractList, 'Finalized')
    //
    //                 .then(() => {
    //                     dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Records finalized"}));
    //                     dispatchData(changeWorkQueue({ workQueueCGridRefresh: true,
    //                         workQueueCDPGridRefresh:true,actionMenuAction: null,
    //                         workQueueFinalize: false}));
    //
    //                 })})
    //                 .catch(err => {
    //                     err.response.json().then(res => {
    //                         console.log(res);
    //                         dispatchData(changeWorkQueue({ workQueueFinalize: false}));
    //                         dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Finalizing failed"}));
    //                         // errorNotification(
    //                         //     "There was an issue",
    //                         //     `${res.message} [${res.status}] [${res.error}]`
    //                         // )
    //                     });
    //                 })
    //                 .finally(()=>{
    //                     setSubmitting(false)
    //                     dispatchData(changeWorkSubmitting({submitting: false }));});
    //         }
    //         else
    //         {
    //             console.log("finalizing by product");
    //             finalizeProperty(controlsPropertyId,"Unapproved","Residuals")
    //                 .then(() => {
    //                     // successNotification("Contract deleted", `Contract with id ${contractId} was deleted`);
    //                     updateStatusByContractList(selectorContractList, 'Finalized')
    //                 .then(() => {
    //                     dispatchData(changeWorkQueue({ workQueueCGridRefresh: true, workQueueFinalize: false,
    //                         workQueueCDPGridRefresh: true }));
    //                            setSubmitting(false);
    //                     dispatchData(changeWorkSubmitting({submitting: false }));
    //                     dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Records finalized"}));
    //                 })})
    //                 .catch(err => {
    //                     err.response.json().then(res => {
    //                         console.log(res);
    //                         // errorNotification(
    //                         //     "There was an issue",
    //                         //     `${res.message} [${res.status}] [${res.error}]`
    //                         // )
    //                     });
    //                     dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Finalizing failed"}));
    //                 })
    //         }
    //     }}


    const removeContract = (contractId, callback) => {
        // setDeleteOpen(false);
        console.log("contracts fetched due to remove contract");
        deleteContractById(contractId).then(() => {
        // deleteContract(contractId).then(() => {
            // successNotification("Contract deleted", `Contract with id ${contractId} was deleted`);
            callback(fetchContracts);
            dispatchData(changeWorkQueue({refreshPropertyDropdown: true}));
        })
            .catch(err => {
                err.response.json().then(res => {
                    console.log(res);
                });
            })
    }


    const handleMousedRow = (rowFull) => {

        console.log('Contract data from mouseover more icon');
        console.log(rowFull);
        const contractList = contracts
            .filter(rowFull => rowFull.hierarchyNew.indexOf(controlsHierarchy) > -1 && rowFull.contractId > 0)
            .map(item => `${item.contractId}`);
        const arrayedContractList = contracts
            .filter(rowFull => rowFull.hierarchyNew.indexOf(controlsHierarchy) > -1 && rowFull.contractId > 0)
            .map(item => item.contractId);
        console.log("controlsHierarchy", controlsHierarchy);
        console.log("contractList", contractList);
        console.log("contractList JSON", JSON.stringify(contractList));

        dispatchData(changeWorkQueue({
            mousedContractSeriesId: rowFull.seriesId,
            mousedContractSeasonId: rowFull.seasonId,
            mousedContractPropertyId: rowFull.propertyId,
            mousedContractId: rowFull.contractId,
            mousedContractName: rowFull.name,
            mousedContractGuild: rowFull.guild,
            mousedContractLaborGroup: rowFull.laborGroup,
            mousedContractContractLevel: rowFull.contractLevel,
            mousedContractStatus: rowFull.status,
            mousedContractHierarchy: rowFull.hierarchy,
            mousedContractHierarchyNew: rowFull.hierarchyNew,
            mousedContractExceptionType: rowFull.exceptionType,
            mousedContractGroupedStatus: rowFull.groupedStatus,
            mousedContractComboStatus: rowFull.comboStatus,
            mousedContractContractList: JSON.stringify(contractList),
            mousedContractContractIdArray: arrayedContractList,
            refreshContractGrid: false, refreshCdpGrid: false, refreshFoldersGrid: false,
            refreshContractHeader: false, refreshProductDropdown: false,
            cdpDrawerState: false, cdpDrawerMode: null,

            bulkEditSeriesId: rowFull.seriesId,
            bulkEditSeasonId: rowFull.seasonId,
            bulkEditPropertyId: rowFull.propertyId,
            bulkEditLaborGroup: rowFull.laborGroup,
            bulkEditGuild: rowFull.guild,
            bulkEditContractId: rowFull.contractId,
            bulkEditContractLevel: rowFull.contractLevel
        }));
        console.log("controlsLaborGroup", controlsLaborGroup);
        console.log("controlsHierarchy", controlsHierarchy);
        console.log(contracts.filter(contracts => contracts.hierarchyNew.indexOf(controlsHierarchy)  > -1
            && contracts.contractId > 0 )
            .map((item) => {
                return `${item.contractId}`;
            }));
        const contractIdsList = contracts
            .filter(contract => contract.hierarchyNew.indexOf(controlsHierarchy) > -1 && contract.contractId > 0)
            .map(item => `${item.contractId}`);

// Join the array into a single string, separated by commas
        const contractIdsString = contractIdsList.join(',');

        setMyContractList(contractIdsString);
        console.log("Joined Contract List:");
        console.log(contractIdsString);

        // setSelectedContracts(contracts.filter(contracts => contracts.hierarchy.indexOf(rowFull.hierarchy)  > -1)
        //     .map((item) => {
        //         return `${item.contractId}`;
        //     }));
    };


    const handleDeleteClickOpen = () => {
        setDeleteOpen(true);
    };

    const handleDeleteClose = () => {
        setDeleteOpen(false);
    };

    const handleDeleteCancel = () => {
        setDeleteOpen(false);
    };

    // this calls on the "removeContract" method above once the user confirms they want to delete a contract.
    const handleDeleteConfirm = () => {
        // const handleDeleteConfirm = (contractId, callback) => {
        setDeleteOpen(false);
        //     //for some reason I think I'm using the wrong id here to place it into "contractId"
        //     // below, it says to use the first part as the first argument in removeContract, assinging a value to contractId
        //     // then it says the callback being requested is the "fetchContracts" method
        removeContract();
    };

    const handleRandomize = () => {
        setSubmitting(true)
        randomizeInputCdpvValues(controlsContractId).then(()=>{

            dispatchData(changeWorkQueue({workQueueCDPGridRefresh: true}));
            dispatchData(changeWorkQueue({workQueueCGridRefresh: true}));
        })
            .finally(()=>{setSubmitting(false)});
    };


    const submittingRef = useRef(false);


    const handleTest = () => {
        console.log("test contract initiated");
        // if (Array.isArray(contractArray) && contractArray.length > 0 && submitting !== true) {
        dispatchData(changeWorkQueue({actionMenuAction: null}));
        if (submittingRef.current) return;

        if (!Array.isArray(contractArray) || contractArray.length === 0) return;

        submittingRef.current = true;          // lock immediately

        dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "info", crudMessage: "Test initiated"}));
        dispatchData(changeWorkSubmitting({submitting: true}));
        setSubmitting(true);
        console.log("submitting to test these contracts: selectedContracts ");
        // console.log(selectedContracts);
        console.log(contracts.filter(contracts => contracts.hierarchyNew.indexOf(controlsHierarchy) > -1
            && contracts.contractId > 0)
            .map((item) => {
                return `${item.contractId}`;
            }));
        console.log(JSON.stringify(contracts.filter(contracts => contracts.hierarchyNew.indexOf(controlsHierarchy) > -1
            && contracts.contractId > 0)
            .map((item) => {
                return `${item.contractId}`;
            }).map((contractId, index) => parseInt(contractId))).slice(1, -1)
        );
        // contractUpdate(contractArray, [], [], 'Test Contracts',
        //     null, null, currentUserName, true)
        contractUpdateWithTest(contractArray, [], [], 'Test Contracts',
            null, null, currentUserName, true,
            controlsTestScenarioSelectedNumber, controlsTestScenarioName, controlsTestScenarioPropertyId, controlsTestScenarioPeriodEnd )
            // calcObligationOwed(JSON.stringify(contracts.filter(contracts => contracts.hierarchyNew.indexOf(controlsHierarchy)  > -1
            //     && contracts.contractId > 0 )
            //     .map((item) => {
            //         return `${item.contractId}`;
            //     }).map((contractId,index) => parseInt(contractId))).slice(1, -1))
            // calcObligationOwed('{11797,11798}')
            .then(() => {
                dispatchData(changeWorkQueue({workQueueCSGridRefresh: true}));
                dispatchData(changeWorkSubmitting({submitting: false}));
            })
            .catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({
                    crudOpen: true,
                    crudSeverity: "error",
                    crudMessage: "Test failed"
                }));
                setSubmitting(false);
                dispatchData(changeWorkSubmitting({submitting: false}));
                dispatchData(changeWorkQueue({workQueueCSGridRefresh: true}));

            })
            .finally(() => {
                submittingRef.current = false;     // release lock
                setSubmitting(false);
                dispatchData(changeWorkQueue({actionMenuAction: null,mousedContractContractIdArray: null,
                    testScenarioPeriodEnd: null,
                    testScenarioDefaultPropertyId: null,
                    testScenarioDefaultPropertyName: null,
                    testScenarioList: null,
                    testScenarioNumber: null,
                    testScenarioName: null,
                    testScenarioSelectedNumber: null}));
            });
    };

    const handleCalc = () => {
        console.log("calc contract initiated");
        // if (Array.isArray(contractArray) && contractArray.length > 0 && submitting !== true) {
        dispatchData(changeWorkQueue({actionMenuAction: null}));
        if (submittingRef.current) return;

        if (!Array.isArray(contractArray) || contractArray.length === 0) return;

        submittingRef.current = true;          // lock immediately

            dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "info", crudMessage: "Calc initiated"}));
            dispatchData(changeWorkSubmitting({submitting: true}));
            setSubmitting(true);
            console.log("submitting for calc these contracts: selectedContracts ");
            // console.log(selectedContracts);
            console.log(contracts.filter(contracts => contracts.hierarchyNew.indexOf(controlsHierarchy) > -1
                && contracts.contractId > 0)
                .map((item) => {
                    return `${item.contractId}`;
                }));
            console.log(JSON.stringify(contracts.filter(contracts => contracts.hierarchyNew.indexOf(controlsHierarchy) > -1
                && contracts.contractId > 0)
                .map((item) => {
                    return `${item.contractId}`;
                }).map((contractId, index) => parseInt(contractId))).slice(1, -1)
            );
        contractUpdateWithTest(contractArray, [], [], 'Calc Contracts',
            null, null, currentUserName, true,
            controlsTestScenarioSelectedNumber, controlsTestScenarioName, controlsTestScenarioPropertyId, controlsTestScenarioPeriodEnd )
            // contractUpdate(contractArray, [], [], 'Calc Contracts',
            //     null, null, currentUserName, true)
                // calcObligationOwed(JSON.stringify(contracts.filter(contracts => contracts.hierarchyNew.indexOf(controlsHierarchy)  > -1
                //     && contracts.contractId > 0 )
                //     .map((item) => {
                //         return `${item.contractId}`;
                //     }).map((contractId,index) => parseInt(contractId))).slice(1, -1))
                // calcObligationOwed('{11797,11798}')
                .then(() => {
                    dispatchData(changeWorkQueue({workQueueCSGridRefresh: true}));
                    dispatchData(changeWorkSubmitting({submitting: false}));
                })
                .catch(err => {
                    console.log(err)
                    dispatchData(changeCrudSnackbar({
                        crudOpen: true,
                        crudSeverity: "error",
                        crudMessage: "Calc failed"
                    }));
                    setSubmitting(false);
                    dispatchData(changeWorkSubmitting({submitting: false}));
                    dispatchData(changeWorkQueue({workQueueCSGridRefresh: true}));

                })
                .finally(() => {
                    submittingRef.current = false;     // release lock
                    setSubmitting(false);
                    dispatchData(changeWorkQueue({actionMenuAction: null,mousedContractContractIdArray: null}));
                });
        };

    // *************** END CONTROLS *******************************


    // **************************************** BEGIN EXPAND **************************************************************************

    const apiRef = useGridApiRef();

    // State to manage expanded nodes
    const [expandedNodes, setExpandedNodes] = React.useState({});


    const expandNodeByFieldValue = (contracts) => {
        console.log("Expanding the node");
        console.log("expandSeasonNumber: ",expandSeasonNumber);
        console.log("expandProductId: ",expandProductId);
        // console.log("Expanding the node");
        // console.log("series", contracts.find(row => row.contractLevel === "Series").id);
        if (expandHierarchical === true) {
            // // const node1 = filteredCS.find(row => row.id === expandContractSectionId);]
            console.log("Expanding contract data for hierarchical product");
            console.log(contracts);
            const seriesToExpand = contracts.find(row => row.contractLevel === "Series").id;
            console.log("seriesToExpand: ", seriesToExpand)
            apiRef.current.setRowChildrenExpansion(seriesToExpand, true);
            // const seasonToExpand = contracts.find(row => row.contractLevel === "Season"&&row.seasonNumber === 1).id;
            const seasonToExpand = contracts.find(row => row.contractLevel === "Season"&&row.seasonNumber === expandSeasonNumber).id;
            console.log("seasonToExpand: ", seasonToExpand)
            apiRef.current.setRowChildrenExpansion(seasonToExpand, true);

            // const contractTypeToExpand = contracts.find(row => row.displayName === "Residuals"&&row.seasonNumber === 1).id;
            const contractTypeToExpand = contracts.find(row => row.displayName === "Residuals"&&row.seasonNumber === expandSeasonNumber).id;
            console.log("contractTypeToExpand: ", contractTypeToExpand)
            apiRef.current.setRowChildrenExpansion(contractTypeToExpand, true);

            const propertyToExpand = contracts.find(row => row.contractLevel === "Property"&&row.propertyId === (expandProductId ? expandProductId.toString() : '')).id;
            console.log("propertyToExpand: ", propertyToExpand)
            apiRef.current.setRowChildrenExpansion(propertyToExpand, true);

            const laborGroupToExpand = contracts.find(row => row.contractLevel === "Labor Group"
                &&row.propertyId === (expandProductId ? expandProductId.toString() : '')
                &&row.laborGroup === expandLaborGroup).id;
            console.log("laborGroupToExpand: ", laborGroupToExpand)
            apiRef.current.setRowChildrenExpansion(laborGroupToExpand, true);

            if(expandContractLevel === "Option" || expandContractLevel === "Cast" || expandContractLevel === "Engagement")
            {
            const guildToExpand = contracts.find(row => row.contractLevel === "Guild"
                &&row.propertyId === (expandProductId ? expandProductId.toString() : '')
                &&row.laborGroup === expandLaborGroup
                &&row.guild === expandGuild).id;
            console.log("guildToExpand: ", guildToExpand)
            apiRef.current.setRowChildrenExpansion(guildToExpand, true);}

            if( expandOption !== null && (expandContractLevel === "Cast" || expandContractLevel === "Engagement"))
            {
                const optionToExpand = contracts.find(row => row.contractLevel === "Option"
                    &&row.propertyId === (expandProductId ? expandProductId.toString() : '')
                    &&row.laborGroup === expandLaborGroup
                    &&row.guild === expandGuild
                    &&row.option === expandOption).id;
                console.log("optionToExpand: ", optionToExpand)
                apiRef.current.setRowChildrenExpansion(optionToExpand, true);}


            if( expandContractLevel === "Engagement" )
            {
                const castToExpand = contracts.find(row => row.contractLevel === "Engagement"
                    &&row.propertyId === (expandProductId ? expandProductId.toString() : '')
                    &&row.laborGroup === expandLaborGroup
                    &&row.guild === expandGuild
                    &&row.parentId === expandCast).id;
                console.log("castToExpand: ", castToExpand)
                apiRef.current.setRowChildrenExpansion(castToExpand, true);}

        }

        if (expandHierarchical !== true) {
                const propertyToExpand = contracts.find(row => row.contractLevel === "Property"&&row.propertyId === (expandProductId ? expandProductId.toString() : '')).id;
                console.log("propertyToExpand: ", propertyToExpand)
                apiRef.current.setRowChildrenExpansion(propertyToExpand, true);
            const contractTypeToExpand = contracts.find(row => row.displayName === "Residuals").id;
            console.log("contractTypeToExpand: ", contractTypeToExpand)
            apiRef.current.setRowChildrenExpansion(contractTypeToExpand, true);
        }
    };

    //
    // useEffect(() => {
    //     console.log("Contract expand triggered");
    //     if (contracts.length > 0 && expandContracts === true) {
    //         const timeout = setTimeout(() => {
    //             console.log("Expanding contract data...");
    //             expandNodeByFieldValue(contracts);
    //         }, 2000); // Adjust timeout as needed
    //
    //         return () => clearTimeout(timeout);
    //     } else {
    //         console.warn("No contracts data available to expand.");
    //     }
    // }, [contracts, expandContracts]);

    const hasExpandedRef = React.useRef(false);

    useEffect(() => {
        if (!expandContracts) {
            hasExpandedRef.current = false;
            return;
        }

        if (hasExpandedRef.current || contracts.length === 0) return;

        hasExpandedRef.current = true;

        const timeout = setTimeout(() => {
            expandNodeByFieldValue(contracts);

            dispatchData(changeWorkQueue({
                contractExpand: false
            }));
        }, 2000);

        return () => clearTimeout(timeout);
    }, [contracts, expandContracts, dispatchData]);

    // ***************************** END EXPAND **************************************************************


    const healthVis =    "visible";


    // ****************** BEGIN DRILLDOWN ****************************

    const handleDrilldown = (selectContractId,selectContractMcode, selectContractName, selectContractDescription, rowFull) => {
        console.log("Here's the row");
        console.log(rowFull);
        console.log("Here's the mcode from the row");
        console.log(rowFull[1]);
        console.log("Here's the stringify");
        dispatchData(changeWorkQueue({
            selectedContractId: rowFull.contractId,
            selectedContractName: rowFull.name,
            selectedContractLevel: rowFull.contractLevel,
            selectedContractProductId: rowFull.propertyId,
            selectedContractType: rowFull.contractType,
            selectedContractGuild: rowFull.guild,
            selectedContractFailedExpressionCount: rowFull.failedExpressionCount,
            selectedContractFailedFilterCount: rowFull.failedFilterCount,
            selectedContractInputMissingCount: rowFull.inputMissingCount,
            selectedContractPropertyId: rowFull.propertyId,
            selectedContractStatus: rowFull.status,
            selectedContractDescription: rowFull.description,
            selectedContractDisplayFolders: true,
            contractHeaderState: true,
            selectedContractSectionId: 0,
            cId: selectContractId, cMcode: selectContractMcode, cName: selectContractName, cDescription: selectContractDescription,
            workQueueCGridState: false, workViewCSGridState: true, cdpId: 0, dataType: null, value: null,workQueueDrawerState: false, workQueueNewState: false,
            workQueueAdvanceState: true,workQueueExpressionState: false, workQueueCDPGridRefresh: true,
            workQueueCSGridRefresh: true}));
    }

    // ****************** END DRILLDOWN ****************************



    const columns = useMemo(
        () =>
            WorkQueueContractGridColumns({
                handleDrilldown,
                handleMousedRow,
                handleClickedRow,
                handleDeleteCancel,
                handleDeleteClose,
                removeContract,
                fetchContracts,
                deleteOpen,
                expandProductId,
                selectorContractId
            }),
        [
            handleDrilldown,
            handleMousedRow,
            handleClickedRow,
            handleDeleteCancel,
            handleDeleteClose,
            removeContract,
            fetchContracts,
            deleteOpen,
            expandProductId,
            selectorContractId
        ]
    );


    const getTreeDataPath = (contracts) => contracts.hierarchyNew.split('|');

    const groupingColDef = {
        headerClassName: 'colored-header',
        hideDescendantCount: true,
        width: 290,
        backgroundColor: "rgb(0,0,0)",
        // Reduce horizontal indentation per tree level
        offsetMultiplier: .5,
        // ,
        // backgroundColor: contracts.row.propertyId === expandProductId.toString() ? 'yellow' : 'transparent',
    };


    const badgeData = 5;


    // Expand/collapse based on expansionDepth whenever it changes or rows update
    useEffect(() => {
        if (!apiRef.current) return;

        const ids = apiRef.current.getAllRowIds(); // all row ids in the tree
        ids.forEach((id) => {
            const node = apiRef.current.getRowNode(id);
            if (!node) return;

            const shouldExpand =
                selectorExpansionDepth === -1 ? true : node.depth < (selectorExpansionDepth ?? 0);

            apiRef.current.setRowChildrenExpansion(id, shouldExpand);
        });
    }, [selectorExpansionDepth, contracts, apiRef]);


    // ****************** BEGIN RETURN ****************************

    return (
        <Box sx={{ height:800 , width: 680, pl: 1,

            '& .level--0': {backgroundColor: "rgb(30,144,255)"},//https://html-color.codes/blue dodger blue
            '& .level--1': {backgroundColor: "rgb(69,177,232)"},//https://html-color.codes/blue picton blue
            '& .level--2': {backgroundColor: "rgb(135,206,250)"},//https://html-color.codes/blue lightskyblue
            '& .level--3': {backgroundColor: "rgb(137,207,240)"},//https://html-color.codes/blue baby blue
            '& .level--4': {backgroundColor: "rgb(173,216,230)"},//https://html-color.codes/blue light blue
            '& .level--5': {backgroundColor: "rgb(135,206,235)"},//https://html-color.codes/blue skyblue
            '& .level--6': {backgroundColor: "rgb(231,254,255)"},//https://html-color.codes/blue bubbles
            '& .level--8': {backgroundColor: "rgb(244,240,236)"},//https://html-color.codes/grey isabelline
            '& .level--9': {backgroundColor: "rgb(250,250,250)"},//custom
            '& .level--10': {backgroundColor: "rgb(255,255,255)"},//custom
            '& .colored-header': { backgroundColor: "rgba(255, 255, 255, 1)"},
            '& .': {backgroundColor: "rgb(144,33,33)"},//https://html-color.codes/blue dodger blue
        }}
        >
            <Box sx={{  width: 680, pl: 1}}>
                {/*<Stack direction="row" spacing={1}>*/}
                    {/*<Tooltip title={"add new contract"}>*/}
                        <ContractAddFromGridDialogue/>
                    {/*</Tooltip>*/}
                {/*    <Box>*/}
                {/*        <Typography*/}
                {/*            sx={{ fontWeight: 'bold' }}*/}
                {/*            style={{cursor: 'pointer'}}*/}
                {/*        >Contracts</Typography>*/}
                {/*    </Box>*/}
                {/*</Stack>*/}
            </Box>
            {submitBar && <LinearIndeterminate/>}

            <DataGridPro
                treeData
                aria-label="Contracts"
                rows={contracts}
                columns={columns}
                apiRef={apiRef}
                getTreeDataPath={getTreeDataPath}
                groupingColDef={groupingColDef}
                getRowId={(row) => row.id}            // ✅ stable id (remove rowKey)
                density="compact"
                // If you're on MUI X v7+, consider:
                // paginationModel={{ pageSize: 20, page: 0 }}
                pageSize={20}
                rowsPerPageOptions={[20]}

                // Initial sort and initial expansion
                initialState={{
                    sorting: { sortModel: [{ field: 'ordinalNumber', sort: 'asc' }] },
                    treeData: { defaultGroupingExpansionDepth: selectorExpansionDepth ?? 0 }, // ✅ initial only
                }}
                // Optional: applies at creation; priority over defaultGroupingselectorExpansionDepth
                isGroupExpandedByDefault={(node) =>
                    selectorExpansionDepth === -1 || node.depth < selectorExpansionDepth
                }

                // Clean styling
                sx={{
                    backgroundColor: 'rgb(30,144,255)',
                    '& .MuiDataGrid-columnHeaders': { backgroundColor: '#fff' },
                    '& .MuiDataGrid-footerContainer': { backgroundColor: '#fff' },
                    '& .MuiDataGrid-row': (theme) => ({
                        '&.level--1': { /* your row-level styles */ },
                        '& .MuiDataGrid-treeDataGroupingCell': {
                            '--DataGrid-cellOffsetMultiplier': .8, // default is 2
                        },
                        // '& .MuiDataGrid-treeDataGroupingCell': {
                        //     paddingLeft: '0px',
                        //     // marginLeft: '5px',
                        //     // paddingLeft: '4px !important',
                        // },

                        '& .MuiDataGrid-treeDataGroupingCellToggle': {
                            marginRight: '0px',
                            width: 18,
                            minWidth: 18,
                        },
                    }),
                }}

                getRowClassName={(params) => `level--${params.row.recordLevel}`}
            />
                <ProductGuildDialogue
                    selectorGuildMultiSelect={selectorGuildMultiSelect}

                />
             {/*}*/}
        </Box>

    );

    // ****************** END RETURN ****************************


}
